import AccountSymbolArrayField from './AccountSymbolArrayField';

export default AccountSymbolArrayField;
